import { Command } from 'commander';
import { VaultProjectContextService } from '../../services/vault-project-context.service.js';
import { redactVaultItem, unlockVault } from './shared.js';

interface SearchOptions {
    project?: boolean;
    passphrase?: string;
    recoveryKey?: string;
    json?: boolean;
}

export function createVaultSearchCommand(): Command {
    return new Command('search')
        .description('Search decrypted local vault index')
        .argument('<query>', 'Search query')
        .option('--project', 'Filter by detected Jai1 project tags')
        .option('--passphrase <value>', 'Vault passphrase')
        .option('--recovery-key <value>', 'Recovery key')
        .option('-j, --json', 'Output JSON')
        .action(async function (this: Command, query: string, options: SearchOptions) {
            const { store, vmk } = await unlockVault(options);
            let items = await store.searchPlainItems(vmk, query);
            if (options.project) items = new VaultProjectContextService().filterToCurrentProject(items);
            const useJson = !!(options.json || this.optsWithGlobals().json);
            if (useJson) {
                console.log(JSON.stringify({ items: items.map(redactVaultItem) }, null, 2));
                return;
            }
            for (const item of items) {
                console.log(`${item.id}  ${item.type}  ${item.title}`);
                console.log(`  ${item.summary}`);
            }
        });
}
